import styles from "./Section5.module.scss";

export const Section5 = function () {
  return (
    <section id="progOutline" className={`${styles.section5Wrapper} cc--component-container`}>
      <div className={styles.section5Container}>
        <div className={styles.section5Content}>
          <h3>Course Curriculum</h3>
          <p className={styles.subtitle}>
            Over the duration of this online short course, you’ll work through the following modules:
          </p>
          <div className={styles.rowContainer}>
            <div className={styles.firstCol}>
              <p>
                <strong>Module 1 How Knowledge is Constructed</strong>
                <br />
                Discover how reading and knowledge are understood, constructed, and communicated across disciplines, and
                how various theories frame how best to support students in becoming proficient in their fields.
              </p>
              <p>
                <strong>Module 2 How Learning Works</strong>
                <br />
                Discover how reading and knowledge are understood, constructed, and communicated across disciplines, and
                how various theories frame how best to support students in becoming proficient in their fields.
              </p>
              <p>
                <strong>Module 3 Building Rapport</strong>
                <br />
                Learn how to implement rapport-building techniques in order to create a positive, supportive, and
                inclusive learning environment.
              </p>
              <p>
                <strong>Module 4 Lesson Planning and Delivery</strong>
                <br />
                Explore how the backward design framework, and traditional and non-traditional organizational teaching
                strategies (such as storytelling) can be used to plan and deliver an effective lesson.
              </p>
            </div>
            <div className={styles.secondCol}>
              <p>
                <strong>Module 5 Engaging Students</strong>
                <br />
                Learn how best to engage students by incorporating active learning methods in lesson planning.
              </p>
              <p>
                <strong>Module 6 Course and Assignment Design</strong>
                <br />
                Discover the principles and tools needed to ensure effective, relevant, and comprehensive assignment and
                syllabus design.
              </p>
              <p>
                <strong>Module 7 Using Feedback to Improve Your Teaching</strong>
                <br />
                Find out how to become a better teacher by incorporating feedback, as well as how to become a reflective
                practitioner.
              </p>
              <p>
                <strong>Module 8 Teaching Portfolio Preparation</strong>
                <br />
                Explore the value of and processes involved in developing a teaching philosophy and creating a teaching
                portfolio.
              </p>
            </div>
          </div>
          <p className={styles.note}>
            <em>Please note that module titles and their contents are subject to change during course development.</em>
          </p>
        </div>
      </div>
    </section>
  );
};
